import type { SelectHTMLAttributes } from 'react';

import { cn } from '../../lib/cn';

export function Select({ className, children, ...props }: SelectHTMLAttributes<HTMLSelectElement>) {
  return (
    <select
      className={cn(
        'h-9 rounded border border-border bg-card px-2 text-sm text-fg focus:outline-none focus:ring-2 focus:ring-primary/40',
        className,
      )}
      {...props}
    >
      {children}
    </select>
  );
}
